"use client";

import { useState, useEffect } from "react";
import Image from "next/image";

export interface Partner {
  id: number;
  name: string;
  link?: string;
  image_name?: string;
}

interface PartnerInfoProps {
  partners: Partner[];
}

export function PartnerInfo({ partners }: PartnerInfoProps) {
  const [shuffledPartners, setShuffledPartners] = useState(partners);

  useEffect(() => {
    setShuffledPartners([...partners].sort(() => Math.random() - 0.5));
  }, [partners]);

  return (
    <div className="gap-4 p-2">
      <h2 className="text-lg font-bold mb-2">Unsere Partner</h2>
      <div className="grid grid-cols-2 gap-2">
        {shuffledPartners.map((partner) => (
          <a key={partner.id} href={partner.link || "#"} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center text-center group">
            {partner.image_name ? (
              <div className="relative w-full h-24 mb-2">
                <Image src={`/uploads/partner/${partner.image_name}`} alt={partner.name} fill className="object-contain" sizes="(max-width: 768px) 100vw, 50vw" />
              </div>
            ) : (
              <div className="w-12 h-12 bg-blue-200 rounded-full mb-2 flex items-center justify-center text-xs font-bold text-gray-600">{partner.name.charAt(0)}</div>
            )}
          </a>
        ))}
      </div>
    </div>
  );
}
